import { isRSAA, RSAA } from 'redux-api-middleware' // RSAA = '@@redux-api-middleware/RSAA'
import config from '../../config'
import { EstateUtils } from '../../utils'

const logger = console
let {
    app: { purgatoryUrl },
} = config
purgatoryUrl = `${purgatoryUrl.split('/').join('/')}/hubble`

export const HUBBLE_API_TOKEN = '$$HUBBLE_API_SERVER$$'
export const HUBBLE_MAINTENANCE_TOKEN = '$$HUBBLE_MAINTENANCE_SERVER$$'
export const HUBBLE_SOCKET_TOKEN = '$$HUBBLE_SOCKET_SERVER$$'
export const PURGATORY_API_TOKEN = '$$PURGATORY_API_SERVER$$'
export const PURGATORY_MAINTENANCE_TOKEN = '$$PURGATORY_MAINTENANCE_SERVER$$'

/**
 * Sets headers for API calls
 */
const APIUrl =
    ({ getState }) =>
    (next) =>
    (action) => {
        let nextAction = action

        try {
            if (isRSAA(action)) {
                const {
                    [RSAA]: { endpoint },
                } = action
                let replacedEndpoint = null

                switch (true) {
                    case endpoint.includes(HUBBLE_API_TOKEN): {
                        const state = getState()
                        const api = EstateUtils.getAPI(state)

                        if (!api) {
                            console.error('Call to API blocked due to api url is not set yet')
                            return
                        }

                        replacedEndpoint = endpoint.replace(HUBBLE_API_TOKEN, api)
                        break
                    }
                    case endpoint.includes(HUBBLE_MAINTENANCE_TOKEN): {
                        const state = getState()
                        const api = EstateUtils.getAPI(state)

                        if (!api) {
                            console.error('Call to API blocked due to api url is not set yet')
                            return
                        }

                        const maintenanceApi = api.replace('/hubble', '/maintenance')

                        replacedEndpoint = endpoint.replace(HUBBLE_API_TOKEN, maintenanceApi)
                        break
                    }
                    case endpoint.includes(HUBBLE_SOCKET_TOKEN): {
                        const state = getState()
                        const socketServer = EstateUtils.getSocketServer(state)

                        if (!socketServer) {
                            console.error('Call to API blocked due to api url is not set yet')
                            return
                        }

                        replacedEndpoint = endpoint.replace(HUBBLE_SOCKET_TOKEN, socketServer.replace(/\/service$/, ''))
                        break
                    }
                    case endpoint.includes(PURGATORY_API_TOKEN): {
                        replacedEndpoint = endpoint.replace(PURGATORY_API_TOKEN, purgatoryUrl)
                        break
                    }
                    case endpoint.includes(PURGATORY_MAINTENANCE_TOKEN): {
                        const purgMaintUrl = purgatoryUrl.replace('/hubble', '/maintenance')
                        replacedEndpoint = endpoint.replace(PURGATORY_MAINTENANCE_TOKEN, purgMaintUrl)
                        break
                    }
                    default:
                }

                if (replacedEndpoint !== null) {
                    nextAction = {
                        ...action,
                        [RSAA]: {
                            ...action[RSAA],
                            endpoint: replacedEndpoint,
                        },
                    }
                }
            }
        } catch (error) {
            logger.error(error)
        }

        return next(nextAction)
    }

export default APIUrl
